import App, { AppContext } from 'next/app';
import {
  ThemeProvider,
} from 'styled-components';
import {
  createTheme,
  ThemeProvider as MaterialThemeProvider,
} from '@material-ui/core/styles';
import { StylesProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { Layout } from '@/core/components/Layout';
import { AppHead } from '@/core/components/AppHead';
import { wrapper } from '@/core/store/store';

import { theme } from '@/themes/main';
import { GlobalStyle } from '@/themes/globalStyles';

type MerixComponent = AppContext['Component'] & { isRestricted?: boolean };
type MerixAppContext = Omit<AppContext, 'Component'> & { Component: MerixComponent };

class MyApp extends App {
  static getInitialProps = wrapper.getInitialAppProps(store => async ({
    Component,
    ctx,
  }: MerixAppContext) => {
    const {
      req,
    } = ctx;
    // Keep nested components `getInitialProps` at the end
    const componentInitialProps = Component.getInitialProps ?
      await Component.getInitialProps(ctx) :
      {};

    return {
      pageProps: {
        ...componentInitialProps,
      },
      pathname: req?.url || ctx.pathname,
    };
  })

  componentDidMount() {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');

    if (jssStyles) {
      jssStyles.parentElement?.removeChild(jssStyles);
    }
  }

  render() {
    const {
      Component,
      pageProps,
    } = this.props;

    const materialTheme = createTheme({
      palette: {
        background: {
          default: '#fff',
        },
      },
      typography: {
        fontFamily: [
          '"Quicksand"',
          'sans-serif',
        ].join(','),
      },
    });

    return (
      <ThemeProvider theme={theme}>
        <MaterialThemeProvider theme={materialTheme}>
          <AppHead />
          <GlobalStyle />
          <StylesProvider injectFirst>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </StylesProvider>
          <CssBaseline />
        </MaterialThemeProvider>
      </ThemeProvider>
    );
  }
}

export default wrapper.withRedux(MyApp);
